/* eslint-disable arrow-body-style */

import http from '@gp/utils/httpTS';
import { OHERSKEY } from '@gp/constants/const';

import type { ProjectListParamsType, ProjectSuccessDataType, ProjectPushRecordParamsType } from '@gp/types/project';

type DownloadProjectListParamsType = ProjectListParamsType & {
  // 1: CSV, 2: Excel
  file_type: 1 | 2;
};

// 请求project表格数据
export const getProjectList = (params: ProjectListParamsType): Promise<ProjectSuccessDataType> => {
  return http({
    url: '/api/v1/globalpedia_pc/projectlist',
    method: 'POST',
    data: params,
    formatData: (res: any) => {
      if (!Array.isArray(res?.items)) return res;
      // 之前的completed处理成现在对应的status
      const orgData = {
        ...res,
        items: res?.items?.map((t: any) => {
          const workplans =
            t?.updates_info && t?.updates_info?.content && t?.updates_info?.content?.workplans
              ? t?.updates_info?.content?.workplans
              : [];
          const newUpdatesInfo =
            Array.isArray(workplans) && workplans?.length > 0
              ? {
                ...t?.updates_info,
                content: t?.updates_info?.content
                  ? {
                    ...t?.updates_info?.content,
                    workplans: workplans?.map((item) => {
                      return {
                        ...item,
                        status:
                              !item?.status && item?.hasOwnProperty('completed')
                                ? item?.completed
                                  ? 4
                                  : 1
                                : item?.status,
                      };
                    }),
                  }
                  : t?.updates_info?.content,
              }
              : t?.updates_info;

          return {
            ...t,
            updates_info: newUpdatesInfo,
          };
        }),
      };

      return orgData;
    },
  }) as any;
};

// 下载project表格数据
export const downloadProjectList = (params: DownloadProjectListParamsType, errorHandler = true): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/projectlist/download',
    method: 'POST',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler,
  });
};

// 请求project搜索下拉框数据
export const getSearchList = (params: { projectName: string }): Promise<ProjectSuccessDataType> => {
  return http({ url: '/api/v1/globalpedia_pc/pipeline/associateSearch', method: 'GET', params }) as any;
};

//  获取projectList页面下拉框的数据值
export const getSelectsFilter: () => Promise<IPipelineProjectListFilterConditionsDTO> = () => {
  return http({
    url: '/api/v1/globalpedia_pc/pipeline/selects',
    method: 'GET',
    formatData: (data: any = {}) => {
      const { regionData = [], businessOwner } = data;
      // 过滤掉plarform中的all platforms
      const filterOther = regionData.filter((el: any) => el.region === 'OTHER')[0];
      if (filterOther) {
        filterOther.region = OHERSKEY; // 将数据中的 'OTHER' 替换成 ‘Others’
        filterOther.regionAbbre = 'OTHERS';
        const { countryData = [] } = filterOther;
        const countryOther = countryData.filter((el: any) => el.country === 'OTHER')[0];
        if (countryOther) {
          countryOther.country = OHERSKEY;
          countryOther.countryAbbre = 'OTHERS';
        }
      }
      return {
        ...data,
        business_owner: businessOwner || [],
        // platform: orgPlatform,
      };
    },
  }) as any;
};

// 获取Studio筛选器数据
export const getStudioList = (params?: { type: 1 }): Promise<{ id: string; name: string }[]> => {
  return http({ url: '/api/v1/globalpedia_pc/pipeline/studios', method: 'GET', params }) as any;
};

// 获取产品编辑的Studio筛选器数据
export const getEditProductStudioList = (params?: { type: 1 }): Promise<{ id: string; name: string }[]> => {
  return http({ url: '/api/v1/globalpedia_pc/pipeline/studios_add', method: 'GET', params }) as any;
};

// 查询联想搜索的记录
export const queryRecord = (params: { type: number; project_id?: string }): Promise<ProjectSuccessDataType> => {
  return http({ url: '/api/v1/globalpedia_pc/pipeline/associateSearch/queryRecordV2', method: 'GET', params }) as any;
};

// const getNewParams = (Params) => {
//   const newParams = platform;
//   delete newParams.platform;
// }

// 添加搜索记录
export const pushRecord = (params: ProjectPushRecordParamsType): Promise<ProjectSuccessDataType> => {
  const newParams = params;
  delete newParams?.platform;
  return http({
    url: '/api/v1/globalpedia_pc/pipeline/associateSearch/pushRecordV2',
    method: 'POST',
    data: newParams,
  }) as any;
};

// 删除搜索记录
export const deleteRecord = (params: { id: string }): Promise<ProjectSuccessDataType> => {
  return http({ url: '/api/v1/globalpedia_pc/pipeline/associateSearch/delRecord', method: 'GET', params }) as any;
};

// project list编辑态修改数据
export const projectListExecuteEdit = (params: {
  field_edit: {
    progress: string;
    priority: string;
    launch_date: string;
    key_question: string;
    project_id: string;
    current_milestone: string;
  }[];
  second_sort: {
    project_id: string;
    position: number;
  }[];
}) => {
  return http({
    url: '/api/v1/globalpedia_pc/projectlist/edit',
    method: 'POST',
    data: params,
    original: true,
  });
};
